import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { roleMatches } from '../utils/roleUtils';
import Forbidden from '../pages/Forbidden';

interface RoleProtectedRouteProps {
  children: ReactNode;
  roles?: string[]; // 允许访问的角色列表（role_code）
}

const RoleProtectedRoute: React.FC<RoleProtectedRouteProps> = ({ children, roles }) => {
  const { isAuthenticated, isLoading, user } = useSelector((state: RootState) => state.auth);

  // 🔒 安全修复：正在验证token时，显示加载状态
  if (isLoading) {
    return <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh'
    }}>
      <div>正在验证身份...</div>
    </div>;
  }

  // 🔒 安全修复：未认证时，直接跳转登录页
  // 不再检查localStorage的token，因为只有验证通过才会设置isAuthenticated=true
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // 🔒 安全修复：理论上不会出现已认证但无用户信息的情况
  // 但为了防御性编程，仍然保留检查
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (roles && roles.length > 0) {
    const userRoleCode = user?.role_code || user?.role;

    if (!userRoleCode || !roleMatches(userRoleCode, roles)) {
      return <Forbidden />;
    }
  }

  return <>{children}</>;
};

export default RoleProtectedRoute; 
